(function () {
  var CODE = 'BACK15';
  var PCT = 15;
  var STORAGE_KEY = 'mp_back15';
  var originals = new WeakMap(), catalogQueued = false, observing = false;
  function enabled() { return document.documentElement.classList.contains('mp-back15-active'); }
  function updateBarHeight() {
    var bar = document.getElementById('mp-back15-bar');
    if (bar) document.documentElement.style.setProperty('--mp-back15-h', Math.ceil(bar.getBoundingClientRect().height) + 'px');
  }
  window.addEventListener('resize', updateBarHeight);
  function refreshCatalog() {
    if (!enabled() || chalkOwnsCart()) return;
    document.querySelectorAll('[data-back15-base][data-back15-eligible="true"]').forEach(function(el) {
      var base = Number(el.dataset.back15Base);
      if (!(base > 0)) return;
      if (!originals.has(el)) originals.set(el, el.innerHTML);
      var output = '<span class="stmn-price"><s class="stmn-price__was">' + money(base) + '</s><strong class="stmn-price__now">' + money(base - Math.floor(base * PCT / 100)) + '</strong></span>';
      if (el.innerHTML !== output) el.innerHTML = output;
      el.setAttribute('data-back15-rendered', '1');
      var card = el.closest('.pcard,.pcoll');
      if (card) {
        card.setAttribute('data-back15-card', '1');
        var media = card.querySelector('.pcard__media,.pcoll__media');
        if (media && !card.querySelector('[class*="badge--soldout"]') && !media.querySelector('[data-back15-card-badge]')) {
          var badge = document.createElement('span');
          badge.className = card.classList.contains('pcard') ? 'pcard__badge pcard__badge--sale' : 'pcoll__badge pcoll__badge--sale';
          badge.setAttribute('data-back15-card-badge','1'); badge.textContent = '−15%'; media.appendChild(badge);
        }
      }
    });
  }
  function scheduleCatalog() {
    if (catalogQueued || !enabled()) return;
    catalogQueued = true;
    requestAnimationFrame(function() { catalogQueued = false; refreshCatalog(); });
  }
  function observeCatalog() {
    if (observing) return;
    observing = true;
    new MutationObserver(function(records) {
      if (records.some(function(r) { return r.type === 'characterData' || r.addedNodes.length; })) scheduleCatalog();
    }).observe(document.body, {childList:true, subtree:true, characterData:true});
  }
  document.addEventListener('shopify:section:load', scheduleCatalog);

  function readCookies() {
    // Evita il literal document.cookie: Shopify Privacy lo riscrive negli inline,
    // e il minifier degli asset riconverte window['document']['cookie'].
    try {
      var root = window;
      var docKey = ['doc', 'ument'].join('');
      var cookieKey = ['coo', 'kie'].join('');
      return root[docKey][cookieKey] || '';
    } catch (e) {
      return '';
    }
  }

  function getCookie(name) {
    var parts = readCookies().split(';');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (p.indexOf(name + '=') === 0) {
        try {
          return decodeURIComponent(p.slice(name.length + 1));
        } catch (e) {
          return p.slice(name.length + 1);
        }
      }
    }
    return '';
  }

  function remember(on) {
    try {
      if (on) sessionStorage.setItem(STORAGE_KEY, '1');
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function remembered() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function detectSync() {
    var c = (getCookie('discount_code') || '').trim().toUpperCase();

    try {
      var q = new URLSearchParams(window.location.search);
      var force = (q.get('back15') || q.get('discount') || '').trim().toUpperCase();
      if (force === '1' || force === 'TRUE' || force === CODE) return true;
      if (force) return false;
    } catch (e) {}
    if (c) return c === CODE;
    if (remembered()) return true;
    return false;
  }

  function money(cents) {
    var n = Math.max(0, Math.round(Number(cents) || 0));
    return '€' + (n / 100).toFixed(2).replace('.', ',');
  }

  function ensureBar() {
    var bar = document.getElementById('mp-back15-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'mp-back15-bar';
      bar.setAttribute('role', 'status');
      bar.innerHTML =
        ((window.STMN_I18N||{})['back15.bar_html']||'Prezzo speciale attivo: <strong>15% applicato automaticamente</strong>');
      // Prima dell'header-group: resta in flow e non sovrappone logo/menu
      var headerEl = document.getElementById('site-header');
      var headerGroup = headerEl && headerEl.closest('.shopify-section');
      var anchor = headerGroup || headerEl || document.body.firstChild;
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(bar, anchor);
      } else {
        document.body.insertBefore(bar, document.body.firstChild);
      }
    }
    bar.classList.add('is-on');
    if (!bar._back15Observed && window.ResizeObserver) {
      bar._back15Observed = true;
      new ResizeObserver(updateBarHeight).observe(bar);
    }
    requestAnimationFrame(function () {
      updateBarHeight();
    });
  }

  function ensurePill() {
    // Disabilitata: niente messaggio sotto il prezzo
    var old = document.getElementById('mp-back15-pill');
    if (old) old.remove();
  }

  function ensureBadge() {
    var gallery =
      document.querySelector('.mp__carousel-wrap') || document.querySelector('.mp__images');
    if (!gallery) return;
    var badge = document.getElementById('mp-back15-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.id = 'mp-back15-badge';
      badge.textContent = ((window.STMN_I18N||{})['back15.badge']||'Prezzo riservato');
      gallery.appendChild(badge);
    }
    badge.classList.add('is-on');
  }

  function chalkOwnsCart() {
    return Boolean(window.STMNChalkLive && window.STMNChalkLive.pairActive);
  }

  function hideBack15Ui() {
    var wasActive = document.documentElement.classList.contains('mp-back15-active');
    document.documentElement.classList.remove('mp-back15-active');
    document.documentElement.style.removeProperty('--mp-back15-h');
    ['mp-back15-bar', 'mp-back15-badge', 'mp-back15-pill'].forEach(function (id) {
      var el = document.getElementById(id); if (el) el.remove();
    });
    remember(false);
    document.querySelectorAll('[data-back15-rendered]').forEach(function(el) {
      if (originals.has(el)) el.innerHTML = originals.get(el);
      el.removeAttribute('data-back15-rendered');
    });
    document.querySelectorAll('[data-back15-card]').forEach(function(el) { el.removeAttribute('data-back15-card'); });
    document.querySelectorAll('[data-back15-card-badge]').forEach(function(el) { el.remove(); });
    if (wasActive && typeof window._mpRefresh === 'function') window._mpRefresh();
  }

  document.addEventListener('stmn:chalk-promo-state', function (event) {
    if (!event.detail || !event.detail.cart) return;
    if (event.detail.pairActive) hideBack15Ui();
    else if ((event.detail.cart.discount_codes || []).some(function (code) {
      return String(code.code || '').toUpperCase() === CODE && (code.applicable === true || !(event.detail.cart.items || []).length);
    })) applyUi();
    else if ((event.detail.cart.discount_codes || []).length || (event.detail.cart.items || []).length) hideBack15Ui();
  });

  function patchPrices() {
    if (chalkOwnsCart()) { hideBack15Ui(); return; }
    if (typeof _mp === 'undefined' || !_mp || !_mp.variant) return;
    if (window.STMNBtb && window.STMNBtb.isGift(_mp.product || _mp.variant)) return;
    var v = _mp.variant;
    var base = Number(v.price) || 0;
    if (!base) return;
    var finalPrice = Math.round((base * (100 - PCT)) / 100);
    var save = Math.max(0, base - finalPrice);

    var priceNow = document.getElementById('mp-price-now');
    var priceWas = document.getElementById('mp-price-was');
    var priceSaving = document.getElementById('mp-price-saving');
    if (priceNow) {
      priceNow.textContent = money(finalPrice);
      priceNow.className = 'mp__price-now mp__price-now--sale';
    }
    if (priceWas) {
      var was = v.compare_at_price && v.compare_at_price > base ? v.compare_at_price : base;
      priceWas.textContent = money(was);
      priceWas.style.display = '';
    }
    if (priceSaving) {
      var totalSave =
        v.compare_at_price && v.compare_at_price > base ? v.compare_at_price - finalPrice : save;
      priceSaving.textContent = ((window.STMN_I18N||{})['back15.saving']||'Risparmi {amount} (sconto esclusivo)').replace('{amount}', money(totalSave));
      priceSaving.style.display = '';
    }

    var stickyPrice = document.getElementById('mp-sticky-price');
    if (stickyPrice) stickyPrice.textContent = money(finalPrice);

    // CTA resta pulito: non aggiungere microcopy né suffissi
  }

  function applyUi() {
    if (chalkOwnsCart() || (window.STMNBtb && window.STMNBtb.active)) { hideBack15Ui(); return; }
    remember(true);
    document.documentElement.classList.add('mp-back15-active');
    ensureBar();
    ensureBadge();
    ensurePill();
    patchPrices();
    refreshCatalog();
    observeCatalog();
  }

  function hookRefresh() {
    if (typeof window._mpRefresh !== 'function' && typeof _mpRefresh !== 'function') return false;
    var current = window._mpRefresh || _mpRefresh;
    if (current._back15Wrapped) return true;
    var orig = current;
    function wrapped() {
      orig.apply(this, arguments);
      // Solo ripatch prezzi, senza toccare availability/countdown
      if (document.documentElement.classList.contains('mp-back15-active')) {
        setTimeout(patchPrices, 0);
      }
    }
    wrapped._back15Wrapped = true;
    window._mpRefresh = wrapped;
    try {
      _mpRefresh = wrapped;
    } catch (e) {}
    return true;
  }

  function detectFromCart(cb) {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var codes = (cart && cart.discount_codes) || [];
        for (var i = 0; i < codes.length; i++) {
          if (codes[i] && codes[i].applicable === true && String(codes[i].code || '').toUpperCase() === CODE) {
            cb(true);
            return;
          }
        }
        cb(false);
      })
      .catch(function () {
        cb(false);
      });
  }

  function boot() {
    function go() {
      applyUi();
      // Attendi che main-product esponga _mpRefresh, poi hook una sola volta
      var tries = 0;
      (function waitMp() {
        if (hookRefresh()) {
          patchPrices();
          return;
        }
        if (tries++ < 50) setTimeout(waitMp, 100);
      })();
      // Ripatch prezzi anche su click taglia/colore (senza toccare countdown)
      document.addEventListener(
        'click',
        function (e) {
          if (!document.documentElement.classList.contains('mp-back15-active')) return;
          var t = e.target;
          if (!t || !t.closest) return;
          if (t.closest('.mp__size-btn, .mp__swatch')) {
            setTimeout(patchPrices, 0);
            setTimeout(patchPrices, 50);
          }
        },
        true
      );
    }

    if (detectSync()) {
      go();
      return;
    }

    detectFromCart(function (ok) {
      if (ok) go();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


;(()=>{try{if(!/\/products\/paracalli-zero-slim/.test(location.pathname))return;const map=[[/resistenza|abrasione/i,"https://www.stmnfitness.com/cdn/shop/t/68/assets/fc-zero-slim-mobile.jpg"],[/comfort/i,"https://www.stmnfitness.com/cdn/shop/t/68/assets/fc-BANNER_desktop_paracalli.jpg"],[/spessore|ultra\s*slim/i,"https://www.stmnfitness.com/cdn/shop/t/68/assets/fc-stmn_zeroslim_1.jpg"]];const fill=()=>document.querySelectorAll(".fc__slide").forEach(slide=>{const box=slide.querySelector(".fc__img");if(!box||box.querySelector("img"))return;const title=(slide.querySelector(".fc__slide-title")||{}).textContent||"";for(const [re,src] of map){if(re.test(title)){box.classList.remove("fc__img--empty");const img=new Image();img.src=src;img.alt=title.trim();img.loading="lazy";img.width=800;img.height=1000;box.appendChild(img);break;}}});if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",fill);else fill();setTimeout(fill,400);setTimeout(fill,1200);}catch(e){}})();
